import { useEffect, useRef, useState } from "react"
import styled from "styled-components"
import { showDisclaimer } from "@templateroller/helpers/dist/api/requests"

import {
    isSnap,
    isBuild,
    isMobile,
} from '../constants'

const Wrapper = styled.div`
    @keyframes slideIn {
        0% {
            transform: translateY(100%);
            opacity: 0;
        }
        100% {
            transform: translateY(0);
            opacity: .95;
        }
    }

    width: 960px;
    padding: 16px 24px;

    position: fixed;
    bottom: ${isMobile ? '48' : '16'}px;
    left: calc((100% - 960px) / 2);

    display: flex;
    flex-direction: column;
    align-items: center;

    background-color: #fff;
    border: 1px solid #52C7DD;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    box-sizing: border-box;

    color: #606060;

    z-index: 4;
    opacity: 1;
    animation: .3s slideIn;
    transition: background-color .3s;
    user-select: none;

    @media screen and (max-width: 1200px) {
        width: 780px;
        left: calc((100% - 780px) / 2);
    }

    @media screen and (max-width: 960px) {
        width: calc(100% - 20px);
        left: 10px;
    }

    @media screen and (max-width: 640px) {
        bottom: 48px;
    }

    @media screen and (max-width: 480px) {
        width: 100%;
        padding: 16px 10px;
        left: 0;
        border-radius: 0;
    }
`

const Title = styled.div`
    margin-bottom: 8px;

    font-weight: 700;
    font-size: 20px; 
    line-height: 32px;
`

const Description = styled.div`
    margin-bottom: 12px;

    font-weight: 400;
    font-size: 16px;
    line-height: 24px;

    @media screen and (max-width: 480px) {
        font-size: 14px;
        line-height: 20px;
    }
`

const Link = styled.a`
    color: #00AFD0;
`

const Buttons = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`

const Button = styled.button`
    width: 124px;
    height: 44px;
    margin: 0 16px 0 0;
    padding: 0;
    
    display: flex;
    align-items: center;
    justify-content: center;

    background-color: #FC531B;
    border: 1px solid #E33B03;
    box-shadow: inset 0px 2px 0px #FC6736;
    border-radius: 4px;
    outline: none;

    color: #fff;
    font-weight: 700;
    font-size: 16px;

    cursor: pointer;
    transition: background-color .3s;

    &:only-child {
        width: 138px !important;
    }

    &:last-child {
        margin: 0;
    }

    &:hover {
        background-color: #E33B03;
    }

    @media screen and (max-width: 480px) {
        width: 116px;
        height: 36px;
        font-size: 14px;
    }
`

const Disclaimer = () => {
    if (isSnap) return null

    const [show, setShow] = useState<string | false>(false)
    const setCookieRef = useRef<undefined | ((cookieValue?: string) => boolean)>(undefined)

    useEffect(() => {
        showDisclaimer(isBuild).then((resp: {
            status: false | string,
            set?: () => boolean,
        }) => {
            if (!!resp.status && !!resp.set) {
                setCookieRef.current = resp.set
                setShow(resp.status)
            }
        })
    }, [])

    switch (show) {
        case 'cookie':
            return <Wrapper>
                <Title>Notice</Title>
                <Description>
                    This website or its third-party tools use cookies, which are necessary to its functioning and required to achieve the purposes illustrated in the cookie policy. If you want to know more or withdraw your consent to all or some of the cookies, please refer to the <Link href="/privacy-policy" title="TemplateRoller Privacy Policy">cookie policy</Link>.
                </Description>
                <Buttons>
                    <Button
                        onClick={() => {
                            if (setCookieRef.current) {
                                setCookieRef.current()
                                setShow(false)
                            }
                        }}
                    >Accept All</Button>
                </Buttons>
            </Wrapper>
        // case 'ccpa':
        //     return <Wrapper>
        //         <Title>Opt-out of the sale of personal information</Title>
        //         <Description>
        //             We won’t sell your personal information to inform the ads you see. You may still see interest-based ads if your information is sold by other companies or was sold previously.
        //         </Description>
        //         <Buttons>
        //             <Button
        //                 onClick={() => {
        //                     if (setCookieRef.current) {
        //                         setCookieRef.current('dismiss')
        //                         setShow(false)
        //                     }
        //                 }}
        //             >Dismiss</Button>
        //             <Button
        //                 onClick={() => {
        //                     if (setCookieRef.current) {
        //                         setCookieRef.current('optnow')
        //                         setShow(false)
        //                     }
        //                 }}
        //             >Opt-Out</Button>
        //         </Buttons>
        //     </Wrapper>
        default:
            return null
    }
}

export default Disclaimer